// extracted by mini-css-extract-plugin
module.exports = {"user-info":"user-info__XTlYE","menu-icon":"menu-icon__2fMs2","profile":"profile__2Cra1"};